import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import type {AudioTypePanelProps} from '@Panels/audio-type-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'audio-type-modal-panel';

export type AudioTypeModalProps = AudioTypePanelProps;

export default function AudioTypeModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.AUDIO_TYPE_MODAL];
  });

  const height = '280px';
  const mobileHeight = '228px';
  const width = '428px';

  return (
    <Modal mobileHeight={mobileHeight} isBottomSheetOnMobile modalId={MODALS_IDS.AUDIO_TYPE_MODAL} panelId={PANEL_ID} modalHeight={height} modalWidth={width}>
      <LazyPanel
        panelDirectoryName="audio-type-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openAudioTypeModal = (props: AudioTypeModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.AUDIO_TYPE_MODAL,
      panelProps: props,
    })
  );
};
